function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.54825 7.54816L24.322 24.3219",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.09863 24.1949L24.2833 24.3595",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1951 9.09863L24.2834 24.3596",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.629 16.9056L35.6113 16.8985C35.419 16.8985 35.224 16.9172 35.0353 16.8913C34.4664 16.8117 33.9852 16.589 34.0004 15.92C34.0147 15.2509 34.4816 15.0237 35.0764 15.022C37.2159 15.0139 35.6864 15.0139 36.775 15.022C42.0387 15.0229 47.3041 15.03 52.5678 15.0237C54.244 15.0211 55.447 13.8333 55.4264 12.2475C55.4076 10.7511 54.2001 9.56957 52.6939 9.57404C51.1797 9.57851 49.9749 10.8396 50.0205 12.3772C50.0268 12.5686 50.0643 12.7591 50.0777 12.9505C50.1189 13.5345 49.8917 13.9504 49.2844 14.039C48.6744 14.1275 48.3148 13.7805 48.2138 13.2152C48.0313 12.201 48.1127 11.209 48.5876 10.2681C49.5956 8.27713 51.7458 7.29327 53.9077 7.84513C55.9872 8.37552 57.3753 10.2923 57.3011 12.5292C57.2313 14.6579 55.6902 16.4664 53.5105 16.7911C52.3809 16.9602 51.2154 16.9181 50.0661 16.9244C47.254 16.9414 44.4411 16.9298 41.629 16.9298V16.9056Z",
  fill: "#F0F0F5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.5342 19.2115C44.128 19.2115 46.7227 19.2124 49.3165 19.2106C51.0571 19.2106 52.5159 20.4405 52.6581 22.0629C52.8361 24.1067 51.7386 25.3311 49.9229 25.6862C48.2083 26.0207 46.6377 24.9072 46.2871 23.1935C46.1807 22.6702 46.3676 22.2874 46.8703 22.1121C47.3712 21.9377 47.762 22.1264 48.0241 22.5781C48.084 22.681 48.1153 22.7999 48.1609 22.9099C48.4623 23.6317 48.999 23.9358 49.6841 23.774C50.4256 23.5978 50.8576 23.0262 50.7861 22.3152C50.7172 21.6256 50.1653 21.1184 49.4051 21.1131C47.0993 21.0987 44.7934 21.1068 42.4876 21.1068C39.5351 21.1077 38.5398 21.0818 35.5882 21.0818C35.4433 21.0818 35.2984 21.0907 35.1562 21.0737C34.5972 21.0084 34.1902 20.7499 34.1482 20.1435C34.1133 19.6328 34.573 19.2196 35.2107 19.2115C36.7939 19.1936 36.4199 19.2303 38.003 19.2294C39.1801 19.2285 40.3571 19.2285 41.5342 19.2285V19.2115Z",
  fill: "#F0F0F5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.1171 12.7488C36.5564 12.7488 36.9511 12.7556 35.3912 12.7458C34.6256 12.7413 34.1524 12.3863 34.1399 11.8469C34.1265 11.27 34.6184 10.8756 35.4073 10.8738C38.4331 10.8693 39.5035 10.8776 42.5293 10.8732C43.3495 10.8714 43.9326 10.3866 44.0015 9.68896C44.0713 8.98773 43.6232 8.35806 42.93 8.18365C42.2574 8.0146 41.6465 8.37863 41.3263 9.1845C41.0991 9.75514 40.744 10.0619 40.1144 9.875C39.5285 9.70058 39.3344 9.17377 39.5679 8.46002C39.9587 7.25971 41.1537 6.34204 42.4229 6.26601C43.7779 6.18551 45.0605 6.95561 45.6052 8.17918C46.5703 10.3473 45.0453 12.7255 42.6581 12.7515C41.1447 12.7684 39.6305 12.755 38.1171 12.755V12.7488Z",
  fill: "#F0F0F5"
});

function SvgWindNw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 32,
    viewBox: "0 0 58 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindNw);
export default __webpack_public_path__ + "static/media/wind-NW.30048b15.svg";
export { ForwardRef as ReactComponent };